<template>
  <div>    
    <MainNavBar />
    <Hero :hero="heroIntelligentPDF" /> 
    <Section :content="boostProductivity" /> 
    <section-search />
    <!--Section :content="findNeedle" /--> 
    <Section :content="navigate" /> 
    <Section :content="instantAccess" /> 
    <Section :content="reviewTags" /> 
    <!--SectionIntelligentPDF /> 
    <Section :content="saveTime" /> 
    <Section :content="read" />
    <Section :content="infoSearch" /> 
    <Section :content="crosslink" />    
    <Section :content="insideIntelligentPdf" /> 
    <Section :content="navigate" /-->    
    <CallToAction :content="ipdfCTA" />
    <GmxFooter /> 
  </div>
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import SectionSearch from '@/components/section-search.vue';
import CallToAction from '@/components/call-to-action.vue';
import GmxFooter from '@/components/footer.vue';

export default {
  name: 'IntelligentPDF',
  components: {
    MainNavBar,
    Hero,
    Section,
    SectionSearch,
    CallToAction,
    GmxFooter,
  },
  data() {
    return { 
      heroIntelligentPDF: { 
        eyebrow: 'Linked Search Results',
        img: 'hero-intelligentPDF.png',
        header: 'Find information 10x faster',
        subheader: 'PDF files are transformed into structured and linked information that is instantly searchable',
        videoId: '686343471',
        buttons: []
      },
      boostProductivity: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Boost Productivity',
        paragraphs: [],
        id: 'boost-productivity',
        image: 'potential-time-savings.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
        html: 
          '<div>' + 
          ' <h5 class="mb-4">Link or create, store and find the information needed to take action.</h5>' + 
          ' <h5 class="mb-4">\"We estimate that our employees each use about one hour per day searching for information\"</h5>' +
          ' <h5 class="mb-4">- Large EU Construction Company</h5>' +
          '</div>'
      },
      /*findInfo: { 
        header: 'Easily find information across thousands of documents',
        headerIcon: '',
        id: 'find-info',
        image: 'crosslink-search-results-crop.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-neon-blue-grad',
        html: 
          '<div>' + 
          ' <h5 class="mb-4">Pinpoint actionable information from thousands of documents simply by using two or more search words.</h5>' + 
          '</div>'
      },
      findNeedle: { 
        header: 'Find the needle in the haystack',
        headerIcon: '',
        id: 'find-needle',
        image: 'crosslink-search-results-crop.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-neon-blue-grad',
        html: 
          '<div>' + 
          ' <h5 class="mb-4">Use two or more search words and you will from thousands of documents pinpoint the information you need to take action.</h5>' + 
          '</div>'
      },*/
      navigate: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Navigate to specific sheets from anywhere in the set',
        paragraphs: [
          'Manually searching through large sheet sets can take a long time, even more so on mobile devices.',
          'With Trinity reading and separating the sheet sets for you, clickable hyperlinks to referenced sections are created on each sheet so that you can navigate to specific sections from wherever you are in the set.'
        ],
        id: 'navigate',
        image: 'navigate-pages-and-sheets-web.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
        /*html: 
          '<div>' + 
          ' <h5 class="mb-4">Manually searching through large sheet sets can take a long time, even more so on mobile devices.</h5>' + 
          ' <h5 class="mb-4">With Trinity reading and separating the sheet sets for you, clickable hyperlinks to referenced sections are created on each sheet so that you can navigate to specific sections from wherever you are in the set.</h5>' +
          '</div>'*/
      },
      instantAccess: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Access all related information, with one click',
        paragraphs: [],
        id: 'instant-access',
        image: 'crosslink-search-results.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-neon-blue-grad',
        html: 
          /*'<div>' + 
          ' <h5 class="mb-4">Trinity creates hyperlinks between all documents with related tags.</h5>' + 
          ' <h5 class="mb-4">Access related RFIs, CORs, emails, specifications, contracts, receipts, and drawing sheets from any document that shares the same tag.</h5>' + 
          '</div>'*/
          '<div>' + 
          ' <h5 class="mb-4">Trinity creates hyperlinks to and from all documents that discuss tags.</h5>' + 
          ' <h5 class="mb-4">Example: a room number from a drawing is tagged by Trinity. A hyperlink is available to and from all RFIs, CORs, emails, specifications, contracts, receipts, and drawing sheets that discuss that tag.</h5>' + 
          '</div>'
      },
      reviewTags: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Easily Review and Approve Trinity\'s Work',
        paragraphs: [
          'Object Tags for Equipment, lines, doors, rooms, drawings and more are automatically found and presented for approval in the review app.  If the tag is approved and new, the system creates a new object with its own URL for the tag and creates links between any units of thought that mention that tag in any other document with live links in the pdfs.',
          'With the Review app, you are able to review all the object tags and drawing tags, titles, disciplines, and revision information for accuracy and make edits and comments before saving to TrinPod\u2122.'
        ],
        id: 'review-tags',
        image: 'drawing-metadata-review.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
        /*html: 
          '<div>' + 
          ' <h5 class="mb-4">Object Tags for Equipment, lines, doors, rooms, drawings and more are automatically found and presented for approval in the review app.  If the tag is approved and new, the system creates a new object with its own URL for the tag and creates links between any units of thought that mention that tag in any other document with live links in the pdfs.</h5>' + 
          ' <h5 class="mb-4">With the Review app, you are able to review all the object tags and drawing tags, titles, disciplines, and revision information for accuracy and make edits and comments before saving to TrinPod\u2122.</h5>' + 
          '</div>'*/
      },
      /*saveTime: { 
        header: '',
        headerIcon: '',
        id: 'save-time',
        image: 'crosslink-search-results.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
        html: 
          '<div class="pl-md-5 px-3 pb-5">' + 
          ' <h2 class="font-italic">"We estimate that our employees each use about one hour per day searching for information."</h2>' + 
          ' <p class="font-italic mb-5">- Large EU Construction Company</p>' + 
          
          ' <h3>Save hours with Trinity reading and linking your PDFs for you.</h3>' + 
          ' <p>With Trinity finding and linking the "Units-of-Thought" in your documents and storing them in your TrinPod&trade;, all of your information is globally searchable across all of your TrinPods&trade; from one single search field.</p>' + 
          ' <p>Whether you\'re on-site or on a slow mobile connection, search finds exactly what you are looking for across all of your TrinPods&trade; quickly.</p>' + 
          '</div>'
      },
      navigate: { 
        header: 'Navigate Instantly to Referenced Documents & Sheets',
        headerIcon: '',
        id: 'navigate-instantly',
        image: 'sheet-links.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light',
        html: 
          '<div class="pl-md-5 px-3 pb-5">' +
          ' <p>Trinity finds all references to other documents and sheets, and creates clickable hyperlinks to them.</p>' + 
          '</div>'
      },
      insideIntelligentPdf: { 
        header: 'Trinity Organizes All of Your Documents',
        headerIcon: '',
        id: 'inside-intelligent-pdf',
        image: 'disciplines.png',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light',
        html: 
          '<div class="pl-md-5 px-3 pb-5">' +
          ' <p>Instead of you manually searching and organizing files yourself, Trinity automatically:</p>' + 
          ' <ul>' + 
          '  <li>Finds each discipline</li>' + 
          '  <li>Structures them into a hierarchy</li>' + 
          '  <li>Reads ands stores every document down to each Unit-of-Thought</li>' + 
          '  <li>Links them all together</li>' + 
          ' </ul>' + 
          ' <p>Everything is registered in SpaceTime, so you have access to the complete history.</p>' + 
          '</div>'
      },
      infoSearch: { 
        header: 'Information Search',
        headerIcon: '',
        id: 'information-search',
        image: 'crosslink-search-results.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue',
        html: 
          '<div class="pl-md-5 px-3 pb-5">' + 
          ' <h2 class="font-italic mb-4">Search draws out the information you are looking for from the documents.</h2>' +
          ' <h5>Entering multiple search words, each stored inside the Units-of-Thought, finds exactly what you are looking for.</h5>' + 
          '</div>'
      },
      read: { 
        header: 'TrinApp\u2122 Read',
        headerIcon: 'trinapp_read.png',
        id: 'read',
        image: 'trinity-read-pdfs.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
        html: 
          '<div class="pl-md-5 px-3 pb-5">' + 
          ' <p>What it does for you:</p>' + 
          ' <ul>' + 
          '  <li>Our conceptual AI agent, Trinity, reads your PDFs for you and transforms them into intelligentPDFs.</li>' + 
          '  <li>The IntelligentPDF™ contains an internal database with the content of the file:</li>' + 
          '   <ul>' + 
          '    <li>Structured from documents, to sections, to single pages or sheets, to Units-of-Thought, to single words.</li>' + 
          '    <li>Each Unit-of-Thought and each word is recorded as a state in space/time, meaning exactly where it is at what time.</li>' + 
          '  </ul>' +
          ' </ul>' + 
          ' <p>Better than current solutions:</p>' + 
          ' <ul>' + 
          '  <li>Saves you time by reading the documents for you.</li>' + 
          '  <li>By using multiple words in your search that all have to be in the Units-of-Thought, search finds exactly the information you need, and no more.</li>' + 
          '  <li>One search finds information stored inside thousands of documents stored on multiple TrinPods&trade;.</li>' + 
          '  <li>Saves you time while using mobile with limited data rates. Find information stored inside large documents and drawing sets with hundreds of sheets.</li>' + 
          '   <ul>' + 
          '    <li>The search results show all the information you need right on your mobile device. No need to download any documents.</li>' + 
          '    <li>If you need to view more results, simply download a single page. No need to download the entire set. It\'s very quick, even on slow mobile connections.</li>' + 
          '  </ul>' +
          ' </ul>' + 
          '</div>'
      },
      crosslink: { 
        header: 'TrinApp\u2122 Crosslink',
        headerIcon: 'trinapp_crosslink.png',
        id: 'crosslink',
        image: 'crosslink-search-results.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
        html: 
          '<div class="pl-md-5 px-3 pb-5">' + 
          ' <p>What it does for you:</p>' + 
          ' <ul>' + 
          '  <li>Crosslink is specifically made to increase your efficiency navigating your information stored within your Construction Drawings and Specifications.</li>' + 
          '  <li>Crosslink adds to Read and uses our proprietary Conceptual AI agent, Trinity, to read the Units-of-Thought.</li>' + 
          '   <ul>' + 
          '    <li>Find the metadata for each sheet and records it to your TrinPod&trade; including; discipline, sheet title, sheet number, reference tags and version.</li>' + 
          '    <li>Trinity uses disciplines to structure and save a larger drawing or specification into its TrinServer&trade; discipline in the IntelligentPDF&trade;.</li>' + 
          '    <li>Trinity creates a supporting document with its metadata, which will be used for auto-import in other applications such as Oracle Aconex.</li>' + 
          '    <li>Trinity uses sheet numbers, sheet titles, and all other reference tags to find references to the sheets and pages from the internal document, or from any other document stored anywhere in your TrinPod&trade;. Trinity creates clickable hyperlinks between them.</li>' + 
          '  </ul>' +
          ' </ul>' + 
          ' <p>Better than current solutions:</p>' + 
          ' <ul>' + 
          '  <li>With instant navigation between referenced sheets, pages and tagged objects, every employee saves a massive amount of time finding the information they need to take action.</li>' + 
          '  <li>Instantly find information that is time-consuming to find with older solutions.</li>' + 
          ' </ul>' + 
          '</div>'
      },*/
      ipdfCTA: {
        header: 'Start using IntelligentPDF\u2122',
        bgClass: 'text-dark bg-light-grad',
        btnText: 'Sign up for free',
        btnVariant: 'neon-blue'
      }
    }
  }
};
</script>

